import { call, fork, put, takeEvery } from 'redux-saga/effects';
import CsQnaApi from '../../../../lib/api/cs/qna/CsQnaApi';
import { setRequestForm, setResponseListForm } from '../../../../lib/common.js';
import noticeExcelDownloadResult from '../../../../lib/noticeExcelDownloadResult';
import csQnaActions from './actions';
import toastMsg from '../../../../lib/toastMsg';
import csQnaToastMsg from '../../../../constants/service/toastMsg/csQnaToastMsg';
import { sendSlackNotification, sendFeedbackToSheet } from '../../../../lib/utils/qnaUtils';

function* fetchList() {
  /**
   *  [상품 문의 리스트] 상품 문의 리스트 요청하기
   */
  yield takeEvery(csQnaActions.GET_QNA_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CsQnaApi.getCsQnaList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(csQnaToastMsg.GET_QNA_LIST_REQUEST_SUCCESS);
        const data = {
          csQnaList: setResponseListForm(result.data.csQnaList, result.data.totalCnt, payload),
        };
        yield put({ type: csQnaActions.GET_QNA_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(csQnaToastMsg.GET_QNA_LIST_REQUEST_ERROR);
    }
  });

  /**
   *  [상품 문의 리스트] 상품 문의 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(csQnaActions.GET_QNA_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CsQnaApi.getCsQnaExcelDownload, setRequestForm(payload, true));
      noticeExcelDownloadResult(payload.email, result.msg);
    } catch (error) {
      toastMsg.error(csQnaToastMsg.GET_QNA_EXCEL_DOWNLOAD_REQUEST_ERROR);
    }
  });

  /**
   *  [상품 문의 상세] 상품 문의 상세 요청하기
   */
  yield takeEvery(csQnaActions.GET_QNA_DETAIL_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CsQnaApi.getCsQnaDetail, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(csQnaToastMsg.GET_QNA_DETAIL_REQUEST_SUCCESS);
        const data = {
          qnaInfo: {
            ...result.data.qnaInfo,
            usersOtherQna: setResponseListForm(
              result.data.qnaInfo.usersOtherQna.list,
              result.data.qnaInfo.usersOtherQna.totalCnt,
              payload.usersOtherQna,
            ),
          },
          productInfo: result.data.productInfo,
        };
        yield put({ type: csQnaActions.GET_QNA_DETAIL_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(csQnaToastMsg.GET_QNA_DETAIL_REQUEST_ERROR);
    }
  });

  /**
   *  [상품 문의 상세] 유저의 다른 문의 내역 조회하기
   */
  yield takeEvery(csQnaActions.GET_USERS_OTHER_QNA_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CsQnaApi.getCsUsersOtherQnaList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(csQnaToastMsg.GET_QNA_DETAIL_REQUEST_SUCCESS);

        const data = {
          qnaInfo: {
            usersOtherQna: setResponseListForm(
              result.data.qnaInfo.usersOtherQna.list,
              result.data.qnaInfo.usersOtherQna.totalCnt,
              payload,
            ),
          },
        };

        yield put({ type: csQnaActions.GET_USERS_OTHER_QNA_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(csQnaToastMsg.GET_QNA_DETAIL_REQUEST_ERROR);
    }
  });

  /**
   *  [상품 문의 상세] 상품 문의 삭제하기
   */
  yield takeEvery(csQnaActions.CHANGE_QNA_STATUS_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CsQnaApi.updateCsQnaStatus, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(csQnaToastMsg.CHANGE_QNA_STATUS_REQUEST_SUCCESS);
        yield put(
          csQnaActions.setData({
            path: ['csQnaDetail', 'qnaInfo', 'status'],
            value: payload.status,
          }),
        );
      }
    } catch (error) {
      toastMsg.error(csQnaToastMsg.CHANGE_QNA_STATUS_REQUEST_ERROR);
    }
  });

  /**
   *  [상품 문의 상세] 상품 문의 비밀글 여부 변경 요청하기
   */
  yield takeEvery(csQnaActions.CHANGE_QNA_SECRET_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CsQnaApi.changeQnaSecret, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(csQnaToastMsg.CHANGE_QNA_SECRET_REQUEST_SUCCESS);
      yield put(
        csQnaActions.setData({
          path: ['csQnaDetail', 'qnaInfo', 'isSecret'],
          value: payload.isSecret,
        }),
      );
    } catch (e) {
      toastMsg.error(csQnaToastMsg.CHANGE_QNA_SECRET_REQUEST_ERROR, e);
    }
  });

  /**
   *  [상품 문의 상세] 상품 문의 답변하기
   */
  yield takeEvery(csQnaActions.REPLY_QNA_DETAIL_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CsQnaApi.replyCsQnaDetail, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(csQnaToastMsg.REPLY_QNA_DETAIL_REQUEST_SUCCESS);
        const data = {
          timeReply: result.data.timeReply,
          answerDate: result.data.answerDate,
          replyAuthor: result.data.replyAuthor,
        };

        yield put({ type: csQnaActions.REPLY_QNA_DETAIL_SUCCESS, payload: data });

        // 답변 저장 성공 후 슬랙 알림 전송 (AI 답변이 있는 경우)
        if (payload.slackNotifyData) {
          sendSlackNotification(payload.slackNotifyData);
        }

        // 답변 저장 성공 후 피드백 데이터 전송 (AI 답변이 있는 경우)
        if (payload.feedbackData) {
          sendFeedbackToSheet(payload.feedbackData, 'none');
        }
      }
    } catch (error) {
      toastMsg.error(csQnaToastMsg.REPLY_QNA_DETAIL_REQUEST_ERROR);
    }
  });
}

export default function* csQnaSaga() {
  yield fork(fetchList);
}
